// Отслеживаем изменения пути при SPA-навигации
exports.onRouteUpdate = ({ location }, pluginOptions) => {
  // Проверяем, что мы в среде браузера и что Яндекс Метрика инициализирована
  if (typeof window === 'undefined' || typeof window.ym === 'undefined') {
    return null
  }

  const counterId = pluginOptions.counterId || process.env.GATSBY_YANDEX_METRIKA_ID

  if (!counterId) {
    return null
  }

  // Используем текущий путь URL в качестве относительного URL
  const page = location.pathname + location.search + location.hash

  // Отправляем событие хита в Яндекс Метрику
  window.ym(counterId, 'hit', page, {
    referer: document.referrer
  })

  return null
} 